import React from "react";
import styled, { css } from "styled-components";
import { flexColumn, marginToChildren } from "../mixins";

const invertStyles = (inverted) =>
    inverted
        ? css`
              flex-direction: row-reverse;

              img {
                  &:nth-of-type(1) {
                      left: 5%;
                      right: unset;
                      top: 5%;
                      width: 140px;
                  }
                  &:nth-of-type(2) {
                      width: 200px;
                      left: 8%;
                      right: unset;
                      bottom: 8%;
                  }
                  &:nth-of-type(3) {
                      width: 150px;
                      left: 25%;
                      right: unset;
                      top: 8%;
                  }
              }
          `
        : "";

const Container = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    min-height: 250px;
    margin: 0 0 30px;
    padding: 30px;
    background-color: ${({ theme }) => theme.colors.light_grey};

    img {
        display: block;
        position: absolute;
        max-height: 250px;
        object-fit: contain;

        &:nth-of-type(1) {
            right: 5%;
            top: -5%;
            width: 140px;
        }
        &:nth-of-type(2) {
            width: 200px;
            right: 18%;
            bottom: -5%;
        }
        &:nth-of-type(3) {
            width: 150px;
            right: 35%;
            top: 5%;
        }
    }

    @media screen and (min-width: 1250px) {
        ${({ inverted }) => invertStyles(inverted)};
    }

    @media screen and (max-width: 1250px) {
        img {
            &:nth-of-type(1) {
                width: 120px;
                right: 8%;
                top: 10%;
            }
            &:nth-of-type(2) {
                width: 160px;
                right: 20%;
                bottom: 10%;
            }
            &:nth-of-type(3) {
                top: 15%;
                width: 120px;
            }
        }
    }

    @media screen and (max-width: 1050px) {
        min-height: 500px;

        img {
            &:nth-of-type(1) {
                top: unset;
                right: unset;
                bottom: 5%;
                left: 10%;
            }
            &:nth-of-type(2) {
                top: unset;
                right: unset;
                bottom: 13%;
                right: 20%;
            }
            &:nth-of-type(3) {
                top: unset;
                top: 10%;
                right: 5%;
            }
        }
    }

    @media screen and (max-width: 560px) {
        min-height: unset;
        padding: 15px;

        img {
            display: none;
        }
    }
`;

const TextContainer = styled.div`
    ${flexColumn};
    ${marginToChildren()};
    padding: 0 30px;
    width: 55%;
    height: 100%;

    & > ul {
        line-height: 300%;
        padding-left: 15px;
    }

    b {
        text-transform: uppercase;
    }

    @media screen and (max-width: 1050px) {
        width: 100%;
    }
    @media screen and (max-width: 560px) {
        padding: 0 15px;
    }
`;

const BlockDescription = ({
    children,
    inverted,
    iconOne: Ione,
    iconTwo: Itwo,
    iconThree: Ithree,
}) => (
    <Container inverted={inverted}>
        <TextContainer>{children}</TextContainer>
        {Ione && <img src={Ione} alt="Icon" />}
        {Itwo && <img src={Itwo} alt="Icon" />}
        {Ithree && <img src={Ithree} alt="Icon" />}
    </Container>
);
export default BlockDescription;
